import { createContext, Dispatch, FunctionComponent, SetStateAction, useContext, useMemo, useState } from 'react';
import { Object3D } from 'three';

type BloomSelectionContextValue = {
    selections: Object3D[];
    setSelections: Dispatch<SetStateAction<Object3D[]>>;
};

const context = createContext<BloomSelectionContextValue | null>(null);

export const useBloomSelectionContext = (): BloomSelectionContextValue => {
    const value = useContext(context);
    if (!value) {
        throw new Error('useBloomSelectionContext() must be used within a BloomSelectionContextProvider');
    }
    return value;
};

export const BloomSelectionContextProvider: FunctionComponent = ({ children }) => {
    const Provider = context.Provider;
    const [selections, setSelections] = useState<Object3D[]>([]);

    const value = useMemo<BloomSelectionContextValue>(
        () => ({
            selections,
            setSelections,
        }),
        [selections, setSelections]
    );

    return <Provider value={value}>{children}</Provider>;
};
